import { render, staticRenderFns } from "./ppInvestment.vue?vue&type=template&id=2fe0a1b7&"
import script from "./ppInvestment.vue?vue&type=script&lang=js&"
export * from "./ppInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports